<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <modal id="backup-terminate" :state="state" :hideable="!awaitingResponse"
    backdrop @hide="$emit('hide')">
    <template #title>{{ $t('title') }}</template>
    <template #body>
      <div class="modal-introduction">
        <p>{{ $t('introduction[0]') }}</p>
        <p>{{ $t('introduction[1]') }}</p>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-danger"
          :disabled="awaitingResponse" @click="terminate">
          {{ $t('action.yesProceed') }} <spinner :state="awaitingResponse"/>
        </button>
        <button type="button" class="btn btn-link" :disabled="awaitingResponse"
          @click="$emit('hide')">
          {{ $t('action.noCancel') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../modal.vue';
import Spinner from '../spinner.vue';
import request from '../../mixins/request';
import { noop } from '../../util/util';

export default {
  name: 'BackupTerminate',
  components: { Modal, Spinner },
  mixins: [request()],
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      awaitingResponse: false
    };
  },
  methods: {
    terminate() {
      this.request({
        method: 'DELETE',
        url: '/config/backups'
      })
        .then(() => {
          this.$emit('success');
        })
        .catch(noop);
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is the title at the top of a pop-up.
    "title": "Terminate Automatic Backups",
    "introduction": [
      "Are you sure you want to terminate your automatic backups?",
      "You will have to reconfigure them again from scratch to start them again, and this action cannot be undone."
    ]
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Ukončit automatické zálohování",
    "introduction": [
      "Opravdu chcete ukončit automatické zálohování?",
      "Budete je muset znovu nakonfigurovat od nuly, abyste je mohli znovu spustit, a tuto akci nelze vrátit zpět."
    ]
  },
  "de": {
    "title": "Automatische Sicherungskopien beenden",
    "introduction": [
      "Sind Sie sicher, dass Sie die automatischen Sicherungskopien beenden möchten?",
      "Sie müssen Sie danach wieder neue konfigurieren, um sie wieder zu starten. Diese Aktion kann nicht rückgängig gemacht werden."
    ]
  },
  "es": {
    "title": "Terminar copias de seguridad automáticas",
    "introduction": [
      "¿Está seguro que quiere terminar sus copias de seguridad automáticas?",
      "Tendrá que volver a configurarlos desde cero para iniciarlos nuevamente, y esta acción no se puede deshacer."
    ]
  },
  "fr": {
    "title": "Terminer les Sauvegardes Automatiques",
    "introduction": [
      "Êtes-vous sûr de vouloir mettre fin à vos sauvegardes automatiques ?",
      "Vous devrez les reconfigurer à partir de zéro pour les faire redémarrer, et cette action ne peut être annulée."
    ]
  }
}
</i18n>
